<ng-container *ngIf="(data$ | async)!.length && (showPaginator$ | async) && (pagination$ | async) as pagination">
  <div class="u-spacer">
    <anb-pagination
      #pagination
      (onPaginate)="onPaginate.emit($event)"
      [resultStart]="pagination.pageIndex === 0 ? 1 : pagination.pageIndex * pagination.pageSize + 1"
      [resultEnd]="pagination.pageIndex * pagination.pageSize + (data$ | async)!.length"
      [totaal]="pagination.totalItems"
      [page]="pagination.pageIndex + 1"
      [count]="pagination.pageSize"
    >
    </anb-pagination>
  </div>
</ng-container>
